/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FC } from 'react'
import { styled } from 'styled-components/native'

import { SnackBarDefault } from 'ui/designSystem/Snackbar/SnackBarDefault'
import { SnackBarLarge } from 'ui/designSystem/Snackbar/SnackBarLarge'
import { ErrorFilled } from 'ui/svg/icons/ErrorFilled'
import { Validate } from 'ui/svg/icons/Validate'

export type SnackBarProps = {
  id: string
  label: string
  type: SnackBarType
  onClose: () => void
  animationDuration: number
  variant?: 'default' | 'large'
}

export type SnackBarType = 'success' | 'error'

export const SnackBar: FC<SnackBarProps> = ({ variant = 'default', ...props }) => {
  const Icon = props.type === 'success' ? IconSuccess : IconError
  const SnackBarVariant = variant === 'default' ? SnackBarDefault : SnackBarLarge

  return <SnackBarVariant Icon={Icon} {...props} />
}

const IconSuccess = styled(Validate).attrs(({ theme }) => ({
  color: theme.designSystem.color.icon.success,
  size: theme.icons.sizes.smaller,
}))``

const IconError = styled(ErrorFilled).attrs(({ theme }) => ({
  color: theme.designSystem.color.icon.error,
  size: theme.icons.sizes.smaller,
}))``
